import { ParticipantChampionshipStatus } from '../../../models';
import { ResourcesListBasic } from '../../../models/response';
import { ChampionshipService } from '../..';

const getOpenParticipantChampionshipsStatus: () => Promise<
  ResourcesListBasic<ParticipantChampionshipStatus>
> = async () => {
  const participantChampionshipStatus = await ChampionshipService.getParticipantChampionshipsStatus();
  return {
    ...participantChampionshipStatus,
    resources: participantChampionshipStatus.resources.filter(
      ({ canContinueChampionship, isActive }) => canContinueChampionship && !isActive,
    ),
  };
};

export { getOpenParticipantChampionshipsStatus };
